"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperegoClient = exports.StatusCode = exports.AuthKind = void 0;
const auth_1 = require("./auth");
const base_client_1 = require("./base_client");
const response_1 = require("./response");
var auth_2 = require("./auth");
Object.defineProperty(exports, "AuthKind", { enumerable: true, get: function () { return auth_2.AuthKind; } });
var response_2 = require("./response");
Object.defineProperty(exports, "StatusCode", { enumerable: true, get: function () { return response_2.StatusCode; } });
__exportStar(require("./data_types"), exports);
class SuperegoClient extends base_client_1.BaseClient {
    /**
     * @param statusCodeCallback This is called after every request with the response's status code.
     */
    constructor(host, auth, statusCodeCallback) {
        super();
        this.host = host;
        this.auth = auth;
        this.statusCodeCallback = statusCodeCallback;
    }
    /**
     * Returns a new SuperegoClient that can have its requests aborted.
     */
    abortable() {
        const abortableClient = new SuperegoClient(this.host, this.auth, this.statusCodeCallback);
        abortableClient.abortController = new AbortController();
        return abortableClient;
    }
    /**
     * Call this to abort a request. Only works if the client is abortable.
     */
    abort() {
        if (this.abortController === undefined) {
            throw Error('Trying to abort a non-abortable client.');
        }
        this.abortController.abort();
    }
    request(namespace, name, arg, auth) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqInit = {
                body: JSON.stringify(arg),
                method: 'POST',
            };
            if (this.abortController) {
                reqInit.signal = this.abortController.signal;
            }
            const headers = new Headers();
            headers.set('Content-Type', 'application/json');
            if (auth === 'user' || auth === 'user_optional') {
                switch (this.auth.kind) {
                    case auth_1.AuthKind.NoAuth:
                        if (auth === 'user_optional') {
                            break;
                        }
                        else {
                            throw new Error('Route expects auth to be set.');
                        }
                    case auth_1.AuthKind.Bearer:
                        headers.set('Authorization', 'Bearer ' + this.auth.token);
                        break;
                    case auth_1.AuthKind.Cookie:
                        headers.set('As-User', this.auth.userId);
                        reqInit.credentials = 'include';
                        break;
                    default:
                        throw new Error('Unexpected auth kind');
                }
            }
            else if (auth === 'noauth') {
                if (this.auth.kind === auth_1.AuthKind.AcceptCookie) {
                    // Peculiarity where `credentials` must be set for a Set-Cookie
                    // header in the response to be accepted.
                    reqInit.credentials = 'include';
                }
            }
            else {
                throw new Error('Unexpected auth from auto-generated route.');
            }
            reqInit.headers = headers;
            const response = yield fetch(this.host + '/1/' + namespace + '/' + name, reqInit);
            if (this.statusCodeCallback) {
                this.statusCodeCallback(response.status);
            }
            // TODO: Handle 400 errors.
            if (response.status === 200) {
                return { kind: response_1.StatusCode.Ok, result: yield response.json() };
            }
            else if (response.status === 401) {
                return { kind: response_1.StatusCode.BadAuth, error: yield response.json() };
            }
            else if (response.status === 418) {
                return { kind: response_1.StatusCode.Error, error: yield response.json() };
            }
            else if (response.status === 429) {
                return { kind: response_1.StatusCode.RateLimit };
            }
            else if (response.status >= 500) {
                return { kind: response_1.StatusCode.InternalError };
            }
            else {
                throw new Error('Unexpected response status: ' + response.status);
            }
        });
    }
}
exports.SuperegoClient = SuperegoClient;
